const Episodes = () => {
    return (
        <div classname='episodes'>
          This is my Episodes Page  
        </div>
    )
}

export default Episodes
